/** Fusion narration — stage banner overlaid while the timeline is active. */
import { useFusionStore } from '../../stores/useFusionStore';
import { INGEST_STEPS, MAX_STEP } from '../../data/fusionSeed';
import { MODULE_COLOR, MODULE_LABEL, type FusionModule } from '../../types/fusion';

export function FusionNarration() {
  const step = useFusionStore((s) => s.step);
  const playing = useFusionStore((s) => s.playing);
  const timelineExpanded = useFusionStore((s) => s.timelineExpanded);

  // Only show when the officer is working the timeline — removes the permanent card.
  if (!playing && !timelineExpanded) return null;

  const cur = INGEST_STEPS[Math.min(Math.max(step, 1), MAX_STEP) - 1];
  const mod = cur.module as FusionModule;
  const accent = MODULE_COLOR[mod];

  return (
    <div
      className="absolute top-3 left-3 z-10 w-[19rem] rounded-lg border border-border bg-card/95 backdrop-blur shadow-lg p-3 pointer-events-none select-none"
      data-testid="fusion-narration"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-block w-2.5 h-2.5 rounded-full animate-pulse shrink-0" style={{ background: accent }} />
        <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
          Stage {cur.n} / {MAX_STEP} · {MODULE_LABEL[mod]}{playing ? ' · ingesting…' : step >= MAX_STEP ? ' · complete' : ''}
        </span>
      </div>
      <div className="text-sm font-semibold leading-snug">{cur.title}</div>
      <div className="text-[11px] text-muted-foreground mt-0.5 leading-snug">{cur.sub}</div>
      <div className="mt-2.5 flex gap-1">
        {INGEST_STEPS.map((s) => (
          <div key={s.n} className="h-1.5 flex-1 rounded-full transition-colors duration-300"
            style={{ background: s.n <= step ? MODULE_COLOR[s.module as FusionModule] : undefined }}
            data-on={s.n <= step}>
            {s.n > step && <div className="h-full w-full rounded-full bg-muted" />}
          </div>
        ))}
      </div>
    </div>
  );
}
